import { get } from '../../utils/api';

export const getClosureStats = async (closureId) => {
  const {
    data: { data },
  } = await get(`pos/v1/accounting/closure/${closureId}`);
  return data;
};

export const getClosureTransactions = async (closureId, page, pageSize) => {
  console.log(closureId, page, pageSize);
  const {
    data: { data },
  } = await get(`pos/v1/accounting/closure/${closureId}/transactions?page=${page}&pageSize=${pageSize}`);
  return data;
};

export const getClosureItems = async (closureId, page, pageSize) => {
  console.log(closureId, page, pageSize);
  const {
    data: { data },
  } = await get(`pos/v1/accounting/closure/${closureId}/items?page=${page}&pageSize=${pageSize}`);
  return data;
};

export const getAllClosures = async (page, pageSize) => {
  const {
    data: { data },
  } = await get(`pos/v1/accounting/closure?page=${page}&pageSize=${pageSize}`);
  return data;
};
